<div [style.backgroundColor]="'var(--sc-color-' + recordingTagColors[tag] + '-hex)'">
  {{ recordingTagNames[tag] }}
</div>
